import React from "react";
import { ResponsiveLine } from "@nivo/line";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import { Defs, linearGradientDef } from "@nivo/core";
import { area, curveMonotoneX } from "d3-shape";
import { Axis } from "@nivo/axes";
import { scaleLinear, scalePoint, scaleTime } from "d3-scale";

import get_data_for_pos_neg_lines from "./helpers/get_data_for_pos_neg_lines.js";
const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex"
    // gridTemplateColumns: "repeat(12, 1fr)",
    // gridGap: theme.spacing(3)
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    marginBottom: theme.spacing(1)
  },
  divider: {
    margin: theme.spacing(2, 0)
  }
}));

const SimpleLineNivo = ({ in_data }) => {
  let comp_item_resline = [];

  // const t = in_data[0].data;
  // const resDomainDates = t.map((a) => a.date);

  // const pointXScale = scalePoint().range([0, 400]).domain(resDomainDates);
  // pointXScale.type = "point";

  debugger;
  const modified_in_data = get_data_for_pos_neg_lines(in_data);
  console.log("modified_in_data");
  console.log(in_data);
  console.log(modified_in_data);

  const AreaLayer = ({ series, xScale, yScale, innerHeight }) => {
    return (
      <>
        {/* <text x="150" y="105" style="fill:black">Hello World!</text>   */}
        <text x={20} y={-20} fill={"gray"}>
          {series[0].symbol}
        </text>
      </>
    );
  };

  const themess = {
    // "background": "#ffffff",
    textColor: "gray",
    fontSize: 11,
    axis: {
      domain: {
        line: {
          stroke: "#777777",
          strokeWidth: 1
        }
      },
      ticks: {
        line: {
          stroke: "#777777",
          strokeWidth: 1
        }
      }
    },
    grid: {
      line: {
        stroke: "#dddddd",
        strokeWidth: 1
      }
    }
  };

  comp_item_resline = modified_in_data.map(function (d, i) {
    return [
      <>
        {/* <span>{d[0].symbol}</span>, */}
        <Grid key={d[0].symbol} item xs={3}>
          <div
            draggable="true"
            style={{
              maxWidth: "450px",
              margin: "0 auto",
              height: "200px"
            }}
          >
            <ResponsiveLine
              data={d}
              theme={themess}
              margin={{ top: 50, right: 10, bottom: 50, left: 60 }}
              enableGridX={false}
              useMesh={false}
              enableGridY={false}
              enablePoints={false}
              enableArea={true}
              areaOpacity={0.2}
              colors={["rgb(97, 205, 187)", "rgb(244, 117, 96)"]}
              xScale={{
                type: "linear",
                min: 0,
                max: "auto"
              }}
              areaOpacity={0.7}
              yScale={{
                type: "linear",
                min: -0.5,
                max: 1
              }}
              axisLeft={{
                legend: "cumu return",
                legendOffset: 12
              }}
              markers={[
                {
                  axis: "y",
                  value: 0,
                  lineStyle: { stroke: "white", strokeWidth: 2 },
                  legend: "y marker",
                  legendColor: "white",
                  legendOrientation: "vertical"
                }
              ]}
              layers={[
                "grid",
                "markers",
                "areas",
                AreaLayer,
                "lines",
                "axes",
                "points",
                "legends"
              ]}
            />
          </div>
        </Grid>
      </>
    ];
  });

  return (
    <div>
      {" "}
      {in_data && (
        <>
          <Grid container spacing={5}>
            {comp_item_resline}
          </Grid>
        </>
      )}
    </div>
  );
};

export default SimpleLineNivo;
